import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Institute_AISHE_CodeEle from './Institute_AISHE_CodeEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Scholarship" />
            <Institute_AISHE_CodeEle />
        </>
    )
}

export default Main